import * as CryptoJS from 'crypto-js';

export function hashData(data: string) {
    const hash = CryptoJS.SHA256(data);
    return hash.toString(CryptoJS.enc.Hex);
}
